import { render } from "./TennisLive.vue?vue&type=template&id=1982a812&ts=true"
import script from "./TennisLive.vue?vue&type=script&lang=ts"
export * from "./TennisLive.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__